export { SlotChangeCoursesStep, type SlotChangeCoursesStepProps } from "./SlotChangeCoursesStep"
